import React from 'react';
import "./footer.scss";
import { Container, Row, Col, Nav} from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import { FaWhatsapp } from 'react-icons/fa';
import { TiSocialInstagram } from "react-icons/ti";

const footer = () => {

    return (
      <footer>
        <Container fluid>
        <Row>
          <Col xs={8} md={4} className="d-lg-flex align-items-lg-center">
            <svg id="ve_logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.46 88.46">
                <path d="m58.13,42.06c1.89-2.83,3.21-5.29,3.96-7.37.75-2.08.81-3.29.16-3.64-1.29-.64-2.89.43-4.8,3.22-1.82,2.65-3.28,5.81-4.37,9.47-.06.19-.11.38-.17.57-.04.13-.07.25-.11.38-.42,1.51-.72,3.04-.92,4.58,2.28-1.97,4.36-4.38,6.25-7.21Z"/>
                <path d="m44.23,0C19.8,0,0,19.8,0,44.23s19.8,44.23,44.23,44.23,44.23-19.8,44.23-44.23S68.65,0,44.23,0Zm24.21,48.76c-1.89,3.31-4.48,6.22-7.76,8.73-3.29,2.51-6.24,4.11-8.79,3.77-3.77-.5-5.13-1.77-6.63-5.31-.63-1.49-1.02-3.05-1.15-4.66-1.59-.54-2.56-1.5-3.15-2.46-1.33,1.79-2.91,3.56-4.75,5.3-4.61,4.38-8.68,6.57-12.2,6.57-1.08,0-1.99-.27-2.74-.81-.75-.54-1.32-1.36-1.71-2.48-.39-1.12-.55-2.49-.48-4.12.06-1.63.39-3.6.96-5.89.58-2.3,1.43-4.82,2.54-7.57.95-2.36,1.63-4.58,2.06-6.67.43-2.08.62-3.57.58-4.48l-.06-1.35c2.84-.6,4.82.35,5.96,2.86,1.14,2.51.93,5.72-.61,9.63-3.91,9.75-5.95,15.55-6.12,17.39-.13,1.2.19,1.8.96,1.8,2.02,0,4.18-1.92,6.47-5.77,2.3-3.84,4.11-8.06,5.44-12.65.39-1.33.84-3.07,1.35-5.22-1.29-1.59-1.95-3.13-2-4.64-.04-1.5.66-2.51,2.13-3.03,2.23-.64,4.09.07,5.57,2.16,1.48,2.08,1.98,4.8,1.51,8.15.02.01-.58,2.51-.58,2.51-.58,1.9-1.41,3.77-2.51,5.62-.24.4-.49.79-.75,1.18.44,1.19,1.18,1.94,2.05,2.4.02-1.74.31-3.55.89-5.43.26-.82.55-1.62.87-2.4.27-.67.56-1.33.88-1.98.11-.23.22-.45.34-.67.84-1.61,1.74-2.99,2.7-4.15.97-1.16,1.98-2.22,3.03-3.19,1.05-.97,2.08-1.73,3.09-2.29,1.01-.56,1.97-.98,2.87-1.26.68-.21,1.3-.31,1.87-.32,1.36-.19,6.5-.52,7.22,5.63.01.4,0,.72-.04.99h0c0,.05-.01.11-.03.17-.04.18-.08.36-.14.56,0,0,0,.01,0,.02-.03.1-.07.21-.11.32-.67,1.84-2.36,4.15-5.06,6.91-3.16,3.22-6.73,6.18-10.72,8.89-.05,1.85.18,3.33.67,4.44.49,1.12,1.19,1.76,2.09,1.93,1.55.3,3.74-.56,6.57-2.58s5.11-4.66,6.83-7.92c.69-1.29,1.14-1.95,1.36-2,.13-.04.19.19.19.71,0,.64-.32,1.53-.97,2.64Z"/>
            </svg>
          </Col>
          <Col md={4} className="d-none d-md-flex justify-content-md-center align-items-md-center">
            <Nav className="flex-column text-uppercase text-center">
              <Nav.Item><NavLink className="nav-link hover-this" to={"/about"}>About</NavLink></Nav.Item>
              <Nav.Item><NavLink className="nav-link hover-this" to={"/projects"}>Project Archive</NavLink></Nav.Item>
              <Nav.Item><NavLink className="nav-link hover-this" to={"/faqs"}>FAQ</NavLink></Nav.Item>
              <Nav.Item><NavLink className="nav-link hover-this" to={"/contact"}>Contact</NavLink></Nav.Item>
            </Nav>
          </Col>
          <Col xs={4} md={4} className="d-flex flex-column justify-content-center align-items-md-end">
            <div className="d-none d-md-block qrCode"></div>
            <div className="text-nowrap d-none d-md-flex flex-row">
            <a className="hover-this" href="https://wa.me/254703928923" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp className="whatsappMeIcon"/> WHATSAPP ME
            </a>
            </div>
            <div className="d-flex d-md-none justify-content-between align-items-center footerSocials">
            <a href="https://www.instagram.com/vernon_eliamani/" target="_blank" rel="noopener noreferrer">
              <TiSocialInstagram size={35}/>
            </a>
            <a href="https://wa.me/254703928923" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp size={35}/>
            </a>
            </div>
          </Col>
        </Row>
        <Row style={{ marginTop: '2rem' }}>
          <Col xs={8} md={4}>
          <p>Copyright © {new Date().getFullYear()} <em className="d-md-none"> Vernon Eliamani. All Rights Reserved.</em></p>
          </Col>
          <Col md={4} className="d-none d-md-block">
          <p className="text-center">Vernon Eliamani. All Rights Reserved.</p>
          </Col>
          <Col xs={4} md={4} className="text-nowrap text-uppercase d-flex justify-content-between align-items-center justify-content-md-end">
          <NavLink className="hover-this" to={"/"} style={{ marginLeft: '-0.5rem'}}>PRIVACY POLICY</NavLink>
          <NavLink className="hover-this" to={"/"} style={{ marginLeft: '0.5rem'}}>Contract</NavLink>
          </Col>
        </Row>
      </Container>
    </footer>
    );
}

export default footer;